import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Columns3, ChevronDown, Check } from 'lucide-react'
import { PanelType } from './PanelToggle'

interface PanelMenuProps {
  availablePanels: PanelType[]
  activePanels: Set<PanelType>
  onToggle: (panel: PanelType) => void
}

const panelLabels: Record<PanelType, string> = {
  preview: 'Preview',
  browser: 'Server Browser',
  files: 'Files',
  docs: 'Docs',
  git: 'Source & Release',
}

export default function PanelMenu({
  availablePanels,
  activePanels,
  onToggle,
}: PanelMenuProps) {
  if (availablePanels.length === 0) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          title="Toggle workspace panels"
          aria-label="Panels"
          className="flex items-center gap-1.5 text-sm text-foreground/70 hover:text-foreground transition-colors px-1.5 py-0.5 rounded hover:bg-secondary"
        >
          <Columns3 className="w-3.5 h-3.5" />
          <span>Panels</span>
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="w-44 bg-card border border-border rounded-lg shadow-lg z-50 py-1"
          align="end"
          sideOffset={4}
        >
          {availablePanels.map((panel) => (
            <DropdownMenu.Item
              key={panel}
              className="w-full px-3 py-2 text-left text-sm hover:bg-secondary flex items-center gap-2 outline-none cursor-pointer"
              onSelect={(e) => {
                e.preventDefault()
                onToggle(panel)
              }}
            >
              <span className="flex-1">{panelLabels[panel]}</span>
              {activePanels.has(panel) && <Check className="w-3.5 h-3.5 text-primary" />}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
